import {ThemeIconKey} from 'platform/foundation';
import {LocaleDateTimeFormat} from 'platform/locale';

import {VehicleAuditStatusLogs} from '@dms/api/core';
import i18n from '@dms/i18n';

import {parseDate} from 'shared/web';

import {getStatusTranslation} from './getStatusTranslation';

export const getPopoverHeaderData = (
  formatDateTime: (dateTimeFormat: LocaleDateTimeFormat, value: Date) => string,
  data?: VehicleAuditStatusLogs | null
) => {
  if (!data) {
    return null;
  }

  const newData: {title: string; describe: string; icon: ThemeIconKey}[] = data.map(
    (item, index) => {
      const isItLastIndex = index === data.length - 1;

      const resultTitle = isItLastIndex
        ? `${i18n.t('page.inspection.created')}`
        : `${i18n.t('page.inspection.changeTo')} ${getStatusTranslation(item.status).toLowerCase()}`;

      return {
        title: resultTitle,
        describe: `${formatDateTime('dateTimeLong', parseDate(item.updatedAt))} • ${item.author.label}`,
        icon: 'paste',
      };
    }
  );
  return newData;
};
